import { put, takeLatest, delay } from "redux-saga/effects";
import { postLogoutApi } from "store/api/LoginApi";
import { LOGOUT_REQUEST } from "../../actions/LoginPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postLogout() {
	yield put(globalAction.openLoadingPage());
	const res = yield postLogoutApi();
	try {
		if (res?.code === 0) {
			yield showMessage(false, res?.message);
			localStorage.clear();
			window.location.replace("/");
		} else {
			yield showMessage(true, res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postLogoutSaga() {
	yield takeLatest(LOGOUT_REQUEST, postLogout);
}

export default postLogoutSaga;
